import type { FC } from 'react';

import { Pagination } from '@packages/shared';
import type { FragmentType } from '@packages/gql/generated/shopping';
import { getFragmentData, graphql } from '@packages/gql/generated/shopping';

import { usePaging } from '../../hooks/usePaging';

export const ProductListPaginationFragment = graphql(/* GraphQL */ `
  fragment ProductListPaginationFragment on SearchProductResult {
    ...UsePagingFragment
  }
`);

export type ProductListPaginationProps = {
  maskedData: FragmentType<typeof ProductListPaginationFragment>;
};

/**
 * ProductListPagination component description displayed in storybook
 * */
export const ProductListPagination: FC<ProductListPaginationProps> = ({ maskedData }) => {
  const data = getFragmentData(ProductListPaginationFragment, maskedData);

  const { pageCount, currentPage, pushPageChange } = usePaging(data);

  return (
    <Pagination
      shape="rounded"
      count={pageCount}
      page={currentPage}
      onChange={(_, page) => pushPageChange(page)}
      color="primary"
    />
  );
};
